import OfferStandardsView from './OfferAnalyzerResultView'
export default OfferStandardsView
